// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d47bd9b7","453":"f6f2e982","455":"bac51e3e"}[chunkId] + ".chunk.js";
};